<template>
    <div class="error-box">
        <h1>Error with code {{error.status}} occured ({{error.header}})</h1>
        <div class="error-detail">{{error.detail}}</div>
        <div class="error-contact">Please report issue through email (support@livesystems.cz) or via phone (+420 724 446 619)</div>
    </div>
</template>

<script>
    export default {
        props: {
            error: Object
        },
        name: "ErrorBox"
    }
</script>

<style scoped lang="scss">
    @import "../../styles/global";

    .error-box {
        padding: 5px;
        background-color: transparentize($openRed, 0.5);
        border-radius: 2px;
        border: 1px dashed $openRed;
    }

    .error-detail {
        max-width: min-content;
        word-wrap: break-word;
        margin-bottom: 10px;
    }

    .error-contact {

    }
</style>